import { AttachmentEntity } from 'src/logic/features/attachments/attachment.service';
import { useRootSelector } from 'src/ui/shared/hooks/root-selector.hook';
import { Icon } from '../../../shared/components/icon/Icon';
import { createAttachmentDownloadUrl } from '../../../shared/helpers/download.helper';
import { useAttachments } from '../hooks/attachments.hook';

interface Props {
    entity: AttachmentEntity;
}

export const DetailsAttachments = ({ entity }: Props): React.ReactElement | null => {
    const attachments = useAttachments(entity);
    const careerhubVersion = useRootSelector(state => state.apiConfiguration.version);

    return attachments.length === 0 ? null : (
        <div className="mb-2">
            <h4 className="font-weight-normal">Attachments</h4>
            {attachments.map(attach => (
                <div key={attach.storedFileId} className="d-flex align-items-center">
                    <a
                        className="btn btn-link pl-0"
                        href={createAttachmentDownloadUrl(
                            careerhubVersion,
                            entity,
                            attach.storedFileId
                        )}
                    >
                        <Icon icon="file-earmark-arrow-down">{attach.title}</Icon>
                    </a>
                </div>
            ))}
        </div>
    );
};
